// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.bs.js");

let convertFragment = PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__Price__PriceRange(props) {
  let maxPrice = props.maxPrice;
  let minPrice = props.minPrice;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment, props.draft);
  let draftProperty = draft.draftProperty;
  let match = draftProperty.propertyType;
  let tmp;
  tmp = match === "FOR_SALE" ? "Lower Price" : "Lower Rent/month";
  let match$1 = draftProperty.propertyType;
  let tmp$1;
  tmp$1 = match$1 === "FOR_SALE" ? "Upper Price" : "Upper Rent/month";
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 12,
        widthMd: 4,
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            labelText: tmp,
            onChange: event => minPrice.onChange(Form__Helpers.intFromFormattedPrice(event)),
            onBlur: param => minPrice.onBlur(),
            onFocus: param => minPrice.onFocus(),
            status: minPrice.status,
            prepend: "$",
            value: Form__Helpers.intOptToFormattedPrice(minPrice.value)
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: minPrice.valid
          })
        ]
      }),
      JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 12,
        widthMd: 4,
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            labelText: tmp$1,
            onChange: event => maxPrice.onChange(Form__Helpers.intFromFormattedPrice(event)),
            onBlur: param => maxPrice.onBlur(),
            onFocus: param => maxPrice.onFocus(),
            status: maxPrice.status,
            prepend: "$",
            value: Form__Helpers.intOptToFormattedPrice(maxPrice.value)
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: maxPrice.valid
          })
        ]
      })
    ]
  });
}

let Components;

let FormSection;

let TextInputField;

let Cell;

let FormUtils;

let Validators;

let make = PropertyWizardRelay__KeyFacts__Price__PriceRange;

exports.Components = Components;
exports.FormSection = FormSection;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.FormUtils = FormUtils;
exports.Validators = Validators;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* Form__Input Not a pure module */
